export const AdminStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const AdminStatusName = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};
